import { PropsWithChildren, ReactNode } from 'react';
import DomPurify from 'dompurify';
import { useTocContext } from '../hooks/useTocContext';

interface TocContentContainerProps extends PropsWithChildren {
  title: ReactNode;
  subtitle: string;
}

export function TocContentContainer({ children, subtitle, title }: TocContentContainerProps) {
  const { contentContainerRef } = useTocContext();

  return (
    <div
      ref={contentContainerRef}
      className='flex-col px-5 py-5 toc-content-container bg-surface w-100 h-100 overflow-auto'
    >
      <span className='text-title-2'>{title}</span>
      <span
        className='text-secondary'
        dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(subtitle) }}
      />

      <div className='flex-col mt-2'>{children}</div>
    </div>
  );
}
